import {extractMessageFromException} from '../../utils/helpers'

export const getDrawingSVGFromServer = (
  primaryKeys,
  planType,
  highlightParameters
) => {
  return new Promise(function(resolve, reject) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      timeout: 10000, // 10 seconds
      callback: function(svgData) {
        resolve(svgData === null ? '' : svgData)
      },
      errorHandler: function(message, exception) {
        let extractedMessage = extractMessageFromException(exception)
        reject(extractedMessage)
      }
    }

    DrawingSvgService.highlightSvgDrawing(
      primaryKeys,
      planType,
      highlightParameters,
      options
    )
  })
}
